import type { ElementType } from 'react';

/** CMS heading-level dropdown ("H2", "H3", ...) to a JSX element type, defaulting to `h2`. */
export function resolveHeadingLevel(titleHeading?: string | null): ElementType {
  return (titleHeading?.toLowerCase() ?? 'h2') as ElementType;
}
